import React, {Component, Fragment} from "react";
import {getMessage} from "./util";

import "./TurnoutTable.css";

class TurnoutTable extends Component {

    render() {

        return (
            <Fragment>
                <div className="row EvColor justify-content-center text-white p-3">
                    <div className="col-12 col-sm-11 col-md-9 col-lg-7">
                        <h4>{getMessage('district_votes',this.props.messages)}</h4>
                    </div>
                </div>
                <br/>
                <div className="row justify-content-center">

                    <div className="col-12 col-sm-11 col-md-9 col-lg-7  p-0">
                        <table className="table table-bordered table-condensed table-turnout">
                            <thead>
                            <tr>
                                <th>{getMessage('district',this.props.messages)}</th>
                                <th>{getMessage('votes',this.props.messages)}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.keys(this.props.snapshot.districts).map(d => (
                                <DistrictRow
                                    key={d}
                                    district={this.props.snapshot.districts[d]}
                                />
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        );
    }

}

class DistrictRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
    }

    doCollapse = event => {
        this.setState({collapsed: !this.state.collapsed});
    };

    render() {

        return (
            <React.Fragment>
                <tr className="district-row">
                    <td>{this.props.district.name}</td>

                    <td>
                        <div className="text-center">
                            {(this.props.district.voters.electronic_voted + this.props.district.voters.manual_voted).toLocaleString(
                                navigator.language,
                                {maximumFractionDigits: 0}
                            )}

                        </div>


                    </td>
                </tr>
                {this.state.collapsed === false &&
                Object.keys(this.props.district.ballotboxes).map(bx => (
                    <BallotBoxRow
                        ballotbox={this.props.district.ballotboxes[bx]}
                        key={this.props.district.district_id + "-" + bx}
                    />
                ))}
            </React.Fragment>
        );
    }
}

class BallotBoxRow extends Component {
    render() {
        const barStyle = {
            width: 100*this.props.ballotbox.voters.electronic_voted/(this.props.ballotbox.voters.electronic_voted +
                this.props.ballotbox.voters.ready) + '%',
            'backgroundColor': '#e7501e47'
        };
        return (
            <tr className="ballotbox-row">
                <td>{this.props.ballotbox.name}</td>
                <td>
                    <div className="text-center">
                        {(this.props.ballotbox.voters.electronic_voted + this.props.ballotbox.voters.manual_voted).toLocaleString(
                            navigator.language,
                            {maximumFractionDigits: 0}
                        )}{" "}
                        de{" "}
                        {(
                            this.props.ballotbox.voters.electronic_voted +
                            this.props.ballotbox.voters.manual_voted +
                            this.props.ballotbox.voters.ready
                        ).toLocaleString(navigator.language, {
                            maximumFractionDigits: 0
                        })}
                    </div>
                    <div className="progress">

                    <div className="progress-bar" role="progressbar"
                         
                         aria-valuenow={this.props.ballotbox.voters.electronic_voted} aria-valuemin="0"
                         aria-valuemax={
                             this.props.ballotbox.voters.electronic_voted +
                             this.props.ballotbox.voters.ready
                         }></div>
                    </div>

                </td>
            </tr>
        );
    }
}

export default TurnoutTable;